import { BaseElement, ClickElement } from './base-element';
import { ElementType } from './element-type';
import { Text } from './text';

export class Menu extends BaseElement {
  menuSections: MenuSection[] = [];

  constructor() {
    super();
    this.elementType = ElementType.menu;
  }
}

export class MenuSection {
  title: string | null = null;
  links: MenuLink[] = [];
}

export class MenuLink extends ClickElement {
  icon: string | null = null;
  title: string | null = null;
  badge: Text | null = null;
}
